import { SAISI } from '@/configuration/bodac/planMedia/planMediaConfig';

export default function genererPlanMedia() {
  return {
    code: null,
    commercialId: null,
    statut: SAISI,
    societeId: null,
    agenceId: null,
    datePM: null,
    dateSignature: null,
    dateDebut: null,
    dateFin: null,
    intervenants: [],
    evenements: [],
    commandes: [],
    devis: [],
    commissions: [],
  };
}
